const baseUrl = `${process.env.NEXT_PUBLIC_WORDPRESS_API_HOSTNAME}`


const path = "/wp-json/wp/v2/"
const navItemPath = "/wp-json/nav/menu"

// We build the url for the fetch requests
function getUrl(path: string, query?: string) {
  const url = `${baseUrl}${path}${query ? `?${query}` : ""}`
  return url
}

export async function getContentBySlug(type, props?) {
  const queryParams = new URLSearchParams({
    ...(props ? props : {})
  }).toString()

  const url = getUrl(`${path}${type}${queryParams ? `?${queryParams}` : ""}`)
  // console.log("url = " + url)
  const response = await fetch(url)
  const content = await response?.json()
  return content
}

export async function getContentById(type, id) {
  const url = getUrl(`${path}${type}/${id}`)
  const response = await fetch(url)
  const content = await response?.json()
  return content
}

export async function getPostsNumber(type, props?) {
  const queryParams = new URLSearchParams({
    ...(props ? props : {})
  }).toString()
  const url = getUrl(`${path}${type}${queryParams ? `?${queryParams}` : ""}`)
  const response = await fetch(url)
  const totalPosts = response.headers.get("X-WP-Total")
  return totalPosts ? parseInt(totalPosts, 10) : 0
}

export const getNavItems = async function (menuName: string = "header_menu") {
  const url = getUrl(`${navItemPath}`)
  const response = await fetch(url)
  const navItems = await response.json()
  return navItems[menuName]
}

export const getFeaturedImageById = async function (id: number) {
  const url = getUrl(`${path}/media/${id}`)
  const response = await fetch(url)
  const featuredMedia = await response.json()
  return featuredMedia
}

export const searchContent = async function(query: string) {
  const url = getUrl(`/wp-json/custom/v1/search?query=${query}`)
  const response = await fetch(url)
  const results = await response.json()
  return results
} 


export const getWorkByClient = async function (props?) {

  const queryParams = new URLSearchParams({
    ...(props ? props : {})
  }).toString()

  const url = getUrl(`/wp-json/custom/v1/work-client${queryParams ? `?${queryParams}` : ""}`)
  const response = await fetch(url)
  const results = await response.json()
  return results
}


export const getAllContentType = async function (type = "pages") {
  const url = getUrl(`/wp-json/wp/v2/${type}`, {per_page: -1})
  const response = await fetch(url)
  const pages = await response.json()
  return pages
}






